import styled from 'styled-components'

interface IAccountCodeSelectStyledProps {}

export const AccountCodeSelectStyled = styled.div<IAccountCodeSelectStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
